/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CommentItem } from '../../models/comment-item';
import { CreateCommentDto } from '../../models/create-comment-dto';

export interface CommentControllerActivate$Params {
  monitoringId: number;
  id: number;
      body: CreateCommentDto
}

export function commentControllerActivate(http: HttpClient, rootUrl: string, params: CommentControllerActivate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommentItem;
}>> {
  const rb = new RequestBuilder(rootUrl, commentControllerActivate.PATH, 'patch');
  if (params) {
    rb.path('monitoringId', params.monitoringId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CommentItem;
      }>;
    })
  );
}

commentControllerActivate.PATH = '/monitoring/{monitoringId}/comments/{id}/activate';
